<script>
import simplebar from "simplebar-vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { schema, doctorNames, chatData, chatMessagesData } from "./data";
import JsonForm from "../../layouts/form";
import Heading from "../../layouts/heading";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";

export default {
  props: {
    category: {},
  },
  page: {
    title: "Information Pages",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, JsonForm,
  simplebar, Heading,
  },
  data() {
    return {
      value: null,
      currentTopic: null,
      currentTopicData: {},
      currentTopicId: null,
      currentTopicActiveStatus: true,
      totalTopics: 0,
      activeTopics: 0,
      enabled5: false,
      editorData: "Hello World",
      chatData: chatData,
      schema: schema,
      formData: {},
      chatMessagesData: chatMessagesData,
      doctorNames: doctorNames,
      topics: null,
      page: {
        title: "Information Pages",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: true,
        addNewModalTitle: 'Create New Information Page',
        formData: {},
        schema: {
          name: {
              type: 'text',
              label: 'Information Page Title',
              placeholder: 'Enter Information Page Name',
              required: true,
              info: false,
              character_count: 50
          },
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      }, 
      submitted: false,
      form: {
        message: "",
      },
      topic: '',
    };
  },
  methods: {
    selectedTopic(data) {
      this.currentTopicId = data.id
      this.currentTopicData = data
      this.currentTopic = {
        title: data.title,
        slug: data.additionalProp1.slug,
        desc: data.description,
        // last_updated: data.lastModifiedDate,
      }
    },
    create(val) {
      if(val)
      {
        // var defaultSlug = this.category.name.replace(/\s/g, '').toLowerCase()+Date.now();
        var defaultSlug = val.name.replace(/\s/g, '').toLowerCase();
        var data = {
          uuid: uuidv4(),
          url: this.currentPractice.additionalProp1.url,
          active: true,
          title: val.name,
          picture: '',
          excerpt: 'Text here',
          description: 'Description here',
          deleted: false,          
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          categoryId: this.category.id,
          cmsId: this.currentCms.id,
          pcnId: this.currentPracticeData.pcnId,
          additionalProp1: {
            slug: defaultSlug,
            categoryName: this.category.name,
            dynamoId: this.currentPractice.additionalProp1.dynamo,            
          }
        };

        api.post('/api/categories/'+this.category.id+'/pages', data)
        .then((response) => {
          // console.log(response);
          this.createSlug(defaultSlug, response.data)

        }, (error) => {
          console.log(error);
        });
      }
    },
    createSlug(defaultSlug, page)
    {
        var data = {
          uuid: uuidv4(),
          name: defaultSlug,
          url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
          path: '/'+defaultSlug,      
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          pageId: page.id,
          cmsId: this.currentCms.id,
          alertId: '',
          additionalProp1: {}
        };
        api.post('/api/pages/'+page.id+'/slug', data)
        .then(() => {
          // console.log(response);
          this.topics.push(page)
          Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          // this.getPages();
        }, (error) => {
          console.log(error);
        });
    },
    deleted() {
      var self = this;
      const params = {
        dynamoId: this.currentPractice.additionalProp1.dynamo,
        categoryName: this.category.name,
        slug: this.currentTopicData.additionalProp1.slug,
        pcnId: this.currentPracticeData.pcnId,
      };

      api.delete('/api/pages/'+this.currentTopicId, { params: params })
      .then(() => {
        // console.log(response);
        Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
        // this.getPages();
        // this.topics.push(page)
        this.topics.splice(this.topics.findIndex(function(i){
          return i.id === self.currentTopicId;
        }), 1);
        this.currentTopic = null
      }, (error) => {
        console.log(error);
      });
    },
    updateSlug(defaultSlug, pageId, page)
    {
        var data = {
          name: defaultSlug,
          url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
          path: '/'+defaultSlug,      
        };
        api.patch('/api/pages/'+pageId+'/slug', data)
        .then(() => {
          // console.log(response);
          Swal.fire("Topic Updated!", "Topic/Slug Updated Successfully!", "success");

          page.id = this.currentTopicId;
          this.selectedTopic(page)
          var objIndex = this.topics.findIndex((obj => obj.id == page.id));
          this.topics[objIndex] = this.currentTopicData
          // this.getPages();
        }, (error) => {
          console.log(error);
        });
    },
    submit() {
      var data = {
        title: this.currentTopic.title,
        excerpt: this.currentTopicData.excerpt,
        url: this.currentTopicData.url,
        description: this.currentTopic.desc,
        active: this.currentTopicActiveStatus,
        pcnId: this.currentPracticeData.pcnId,
        additionalProp1: {
          slug: this.currentTopic.slug,
          oldSlug: this.currentTopicData.additionalProp1.slug,
          categoryName: this.category.name,
          dynamoId: this.currentPractice.additionalProp1.dynamo,
        },
      };

      api.patch('/api/pages/'+this.currentTopicId, data)
      .then(() => {
        // console.log(response);
        this.updateSlug(this.currentTopic.slug, this.currentTopicId, data)

      }, (error) => {
        console.log(error);
      });
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus
    },
    getPages() {
      api.get('/api/categories/'+this.category.id+'/pages')
      .then(response => {
        this.topics = response.data
        this.totalTopics = this.topics.length;
        var count = 0;
        for (var x of this.topics) {
          if (x.active) {
            count++;
          }
        }
        this.activeTopics = count;

        this.selectedTopic(this.topics[0])

        Swal.close();

      })
      .catch(e => {
        console.log(e)
      })  
    },
  },
  watch: {
    currentCms() {
      this.$router.push({ name: 'Pages' }).catch(()=>{});
    },
    currentTopic: function (val) {
      if(val != null)
      this.page.deleteBtn = true;
      // this.page.activeBtn = true;
      this.page.submitBtn = true;
      this.currentTopicActiveStatus = this.currentTopicData.active;
    },
  },
  mounted() {
    this.getPages()

    let timerInterval;
    Swal.fire({
      title: "Loading Information Pages",
      // html: "Fetching news",
      timer: 10000,
      timerProgressBar: false,
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        timerInterval = setInterval(() => {
        }, 100);
      },
      onClose: () => {
        clearInterval(timerInterval);
      }
    }).then(result => {
      if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.timer
      ) {
        console.log("I was closed by the timer"); // eslint-disable-line
      }
    });
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page" :activeStatus="currentTopicActiveStatus" @activateToggle="activateToggle"
    @created="create" @deleted="deleted" @form-submitted="submit"></Heading>

    <div class="d-lg-flex" style="letter-spacing: 0.02em;min-height: calc( 100vh - 144px );">
      <div class="chat-leftsidebar w-25 pr-4 pt-3">
        <div>
          <div class="d-flex mb-2">
            <h5 class="font-size-14 my-2 align-self-sm-center" style="color: #333333">Select a topic</h5>
            <!-- <i class="ri-information-fill my-auto font-size-18 font-gray-color"></i> -->
              <img id="info_tooltip" class="align-self-center mx-2"
              src="@/assets/images/info.svg" alt="">
            <p class="font-size-14 mb-2 mt-2 text-muted ml-auto font-weight-medium">
              <span class="border-right-dark mr-2 pr-1">Total: {{totalTopics}} </span>
              <span> Active: {{activeTopics}}</span>
            </p>
          </div>
          <simplebar style="max-height: 490px" id="scrollElement" data-simplebar-auto-hide="false">
            <ul class="list-unstyled chat-list mr-4">
              <li
                v-for="data of topics"
                :key="data.id"
                @click="selectedTopic(data)"
                :class="{ active: currentTopicData.title == data.title ? true : false}"
              >
                <a href="javascript: void(0);">
                  <div class="media">
                    <div class="media-body overflow-hidden p-2">
                      <p class="text-truncate font-size-16 mb-0 px-2">
                        {{ data.title }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </simplebar>
        </div>
      </div>
      <div class="w-100 mt-4 mt-sm-0" style="border-left: 1px solid #DADCE3;"
      v-if="currentTopic">
        <div class="pt-3 pl-lg-4" style="letter-spacing: 0.02em;">
          <div class="row px-2">
            <JsonForm :page="page" :schema="schema" :formData="currentTopic"></JsonForm>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.border-right-dark {
  border-right: 1px solid #DADCE3;
}
</style>